const colors = ['blue', 'green', 'red'];

export default currentNumberOfBabies =>
  colors[currentNumberOfBabies % colors.length];



// WEBPACK FOOTER //
// ./src/helpers/getNextBabyColor.js